<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>
      <multiselect
        class="custom-select"
        v-model="selected"
        :options="markets"
        :multiple="true"
        :placeholder="$t(tKey + 'placeholder')"
        :closeOnSelect="false"
        :allowEmpty="true"
        :searchable="false"
        select-label=""
        :deselect-label="$t('utils.unselect')"
        :selected-label="$t('utils.selected')"
        label="text"
        track-by="value"
        @input="transmitNewValue()"
      >
        <!--<template slot="selection" 
          slot-scope="{ values }">
          <div v-if="values.length">
            <small class="multiselect__single" v-if="values.length > 1" v-html="`${values.length} ${$tc(tKey + 'selected', values.length)}`" />
            <small class="multiselect__single" v-else v-html="values[0].text" />
          </div>
        </template>-->
      </multiselect>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      tKey: "filter.markets.",
      selected: null,
      icon: "globe",
      key: "markets",
    };
  },
  created() {
    this.getDefaultMarket()
    this.transmitNewValue()
  },
  computed: {
    ...mapGetters('markets', ['markets'])
  },
  methods: {
    getDefaultMarket() {
      this.selected = []
    },
    transmitNewValue() {
      //if(!this.selected.length) this.getDefaultRegion()
      this.$emit("transmit", this.selected, this.key)
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  min-height: 0 !important;
  box-sizing: border-box !important;
}
.multiselect__placeholder,
.multiselect__single {
  margin: 0 !important;
}
.multiselect__tags {
  border: none !important;
  min-height: 0 !important;
  padding: 0 !important;
}
.multiselect__option--selected.multiselect__option--highlight, 
.multiselect__option multiselect__option--selected {
  background: $colorbase-lightest !important;
}
.multiselect__option--highlight {
  background: $colorbase !important;
}
.multiselect__tag {
  margin-bottom: 0px !important;
  background: $colorbase !important;
}
.multiselect__select {
  display: none !important;
}
.multiselect__content-wrapper {
  /* width */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px lightgray; 
    border-radius: 0px;
  }
  
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $colorbase-light; 
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $colorbase; 
  }
}
</style>
